// JCH dashboard data — the shared-number, KPI, report and milestone screens.
// All calls go through the API envelope; callers get the raw `.data`.

import { api } from '../api/client.js';

// Shared numbers overview — equivalent to what JR sees, JCH-scoped.
// Each row: makler id/name/level/semafor/phase/newcomer/user_id/status/assignment_id.
// Returns { maklers, count }.
export async function listJchOverview() {
  const res = await api.get('/maklerOverview/jch');
  return res.data.data;
}

// Detail of one makler — same shape as the JR makler overview detail.
export async function listJchMakler(maklerId) {
  const res = await api.get(`/maklerOverview/makler/${maklerId}`);
  return res.data.data;
}
